"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ablehnenAusbildungsplan", {
  enumerable: true,
  get: function get() {
    return _ablehnenAusbildungsplan.ablehnenAusbildungsplan;
  }
});
Object.defineProperty(exports, "acceptPrivacyPolicy", {
  enumerable: true,
  get: function get() {
    return _acceptPrivacyPolicy.acceptPrivacyPolicy;
  }
});
Object.defineProperty(exports, "addChatParticipant", {
  enumerable: true,
  get: function get() {
    return _addChatParticipant.addChatParticipant;
  }
});
Object.defineProperty(exports, "automaticallySelectCurrentAbteilungForAzubi", {
  enumerable: true,
  get: function get() {
    return _automaticallySelectCurrentAbteilungForAzubi.automaticallySelectCurrentAbteilungForAzubi;
  }
});
Object.defineProperty(exports, "calculateConflictsForAzubi", {
  enumerable: true,
  get: function get() {
    return _calculateConflictsForAzubi.calculateConflictsForAzubi;
  }
});
Object.defineProperty(exports, "commentAufgabe", {
  enumerable: true,
  get: function get() {
    return _commentAufgabe.commentAufgabe;
  }
});
Object.defineProperty(exports, "copyVersetzungsplan", {
  enumerable: true,
  get: function get() {
    return _copyVersetzungsplan.copyVersetzungsplan;
  }
});
Object.defineProperty(exports, "createAbteilung", {
  enumerable: true,
  get: function get() {
    return _createAbteilung.createAbteilung;
  }
});
Object.defineProperty(exports, "createAufgabe", {
  enumerable: true,
  get: function get() {
    return _createAufgabe.createAufgabe;
  }
});
Object.defineProperty(exports, "createChat", {
  enumerable: true,
  get: function get() {
    return _createChat.createChat;
  }
});
Object.defineProperty(exports, "createChatActivity", {
  enumerable: true,
  get: function get() {
    return _createChatActivity.createChatActivity;
  }
});
Object.defineProperty(exports, "createNachweis", {
  enumerable: true,
  get: function get() {
    return _createNachweis.createNachweis;
  }
});
Object.defineProperty(exports, "createNote", {
  enumerable: true,
  get: function get() {
    return _createNote.createNote;
  }
});
Object.defineProperty(exports, "createNotificationsForSelectedAzubiGroups", {
  enumerable: true,
  get: function get() {
    return _createNotificationsForSelectedAzubiGroups.createNotificationsForSelectedAzubiGroups;
  }
});
Object.defineProperty(exports, "createOrUpdateRessourcenplanung", {
  enumerable: true,
  get: function get() {
    return _createOrUpdateRessourcenplanung.createOrUpdateRessourcenplanung;
  }
});
Object.defineProperty(exports, "createTaetigkeit", {
  enumerable: true,
  get: function get() {
    return _createTaetigkeit.createTaetigkeit;
  }
});
Object.defineProperty(exports, "createTermin", {
  enumerable: true,
  get: function get() {
    return _createTermin.createTermin;
  }
});
Object.defineProperty(exports, "createTerminAsAusbilder", {
  enumerable: true,
  get: function get() {
    return _createTerminAsAusbilder.createTerminAsAusbilder;
  }
});
Object.defineProperty(exports, "deleteAbteilung", {
  enumerable: true,
  get: function get() {
    return _deleteAbteilung.deleteAbteilung;
  }
});
Object.defineProperty(exports, "deleteAttachmentFromNachweis", {
  enumerable: true,
  get: function get() {
    return _deleteAttachmentFromNachweis.deleteAttachmentFromNachweis;
  }
});
Object.defineProperty(exports, "deleteAufgabe", {
  enumerable: true,
  get: function get() {
    return _deleteAufgabe.deleteAufgabe;
  }
});
Object.defineProperty(exports, "deleteImage", {
  enumerable: true,
  get: function get() {
    return _deleteImage.deleteImage;
  }
});
Object.defineProperty(exports, "deleteProfileImage", {
  enumerable: true,
  get: function get() {
    return _deleteProfileImage.deleteProfileImage;
  }
});
Object.defineProperty(exports, "deleteTaetigkeit", {
  enumerable: true,
  get: function get() {
    return _deleteTaetigkeit.deleteTaetigkeit;
  }
});
Object.defineProperty(exports, "deleteTermin", {
  enumerable: true,
  get: function get() {
    return _deleteTermin.deleteTermin;
  }
});
Object.defineProperty(exports, "deleteUserAusbilder", {
  enumerable: true,
  get: function get() {
    return _deleteUserAusbilder.deleteUserAusbilder;
  }
});
Object.defineProperty(exports, "deviceRegister", {
  enumerable: true,
  get: function get() {
    return _deviceRegister.deviceRegister;
  }
});
Object.defineProperty(exports, "deviceUnregister", {
  enumerable: true,
  get: function get() {
    return _deviceUnregister.deviceUnregister;
  }
});
Object.defineProperty(exports, "editAbteilung", {
  enumerable: true,
  get: function get() {
    return _editAbteilung.editAbteilung;
  }
});
Object.defineProperty(exports, "einreichenAusbildungsplan", {
  enumerable: true,
  get: function get() {
    return _einreichenAusbildungsplan.einreichenAusbildungsplan;
  }
});
Object.defineProperty(exports, "freigabeZurueckziehenAusbildungsplan", {
  enumerable: true,
  get: function get() {
    return _freigabeZurueckziehenAusbildungsplan.freigabeZurueckziehenAusbildungsplan;
  }
});
Object.defineProperty(exports, "freigebenAusbildungsplan", {
  enumerable: true,
  get: function get() {
    return _freigebenAusbildungsplan.freigebenAusbildungsplan;
  }
});
Object.defineProperty(exports, "getAbteilungenAsFachausbilder", {
  enumerable: true,
  get: function get() {
    return _getAbteilungenAsFachausbilder.getAbteilungenAsFachausbilder;
  }
});
Object.defineProperty(exports, "getAbteilungenForAzubi", {
  enumerable: true,
  get: function get() {
    return _getAbteilungenForAzubi.getAbteilungenForAzubi;
  }
});
Object.defineProperty(exports, "getAllAbteilungen", {
  enumerable: true,
  get: function get() {
    return _getAllAbteilungen.getAllAbteilungen;
  }
});
Object.defineProperty(exports, "getAllChaptersStatusByUser", {
  enumerable: true,
  get: function get() {
    return _getAllChaptersStatusByUser.getAllChaptersStatusByUser;
  }
});
Object.defineProperty(exports, "getAllChaptersStatusFromMyAzubis", {
  enumerable: true,
  get: function get() {
    return _getAllChaptersStatusFromMyAzubis.getAllChaptersStatusFromMyAzubis;
  }
});
Object.defineProperty(exports, "getAllCourses", {
  enumerable: true,
  get: function get() {
    return _getAllCourses.getAllCourses;
  }
});
Object.defineProperty(exports, "getAllCoursesForAzubis", {
  enumerable: true,
  get: function get() {
    return _getAllCoursesForAzubis.getAllCoursesForAzubis;
  }
});
Object.defineProperty(exports, "getAnswers", {
  enumerable: true,
  get: function get() {
    return _ausbildungsplanGetAnswers.getAnswers;
  }
});
Object.defineProperty(exports, "getAnswersAsAusbilder", {
  enumerable: true,
  get: function get() {
    return _ausbildungsplanGetAnswersAsAusbilder.getAnswersAsAusbilder;
  }
});
Object.defineProperty(exports, "getArchivedAusbildungsnachweise", {
  enumerable: true,
  get: function get() {
    return _getArchivedAusbildungsnachweise.getArchivedAusbildungsnachweise;
  }
});
Object.defineProperty(exports, "getAufgabenByAbteilung", {
  enumerable: true,
  get: function get() {
    return _getAufgabenByAbteilung.getAufgabenByAbteilung;
  }
});
Object.defineProperty(exports, "getAusbilder", {
  enumerable: true,
  get: function get() {
    return _getAusbilder.getAusbilder;
  }
});
Object.defineProperty(exports, "getAusbilderAsTrainer", {
  enumerable: true,
  get: function get() {
    return _getAusbilderAsTrainer.getAusbilderAsTrainer;
  }
});
Object.defineProperty(exports, "getAusbilderFeedItems", {
  enumerable: true,
  get: function get() {
    return _getAusbilderFeedItems.getAusbilderFeedItems;
  }
});
Object.defineProperty(exports, "getAusbildungsnachweiseAusbilderDashboard", {
  enumerable: true,
  get: function get() {
    return _getAusbildungsnachweiseAusbilderDashboard.getAusbildungsnachweiseAusbilderDashboard;
  }
});
Object.defineProperty(exports, "getAusbildungsnachweiseAzubiDashboard", {
  enumerable: true,
  get: function get() {
    return _getAusbildungsnachweiseAzubiDashboard.getAusbildungsnachweiseAzubiDashboard;
  }
});
Object.defineProperty(exports, "getAusbildungsplan", {
  enumerable: true,
  get: function get() {
    return _getAusbildungsplan.getAusbildungsplan;
  }
});
Object.defineProperty(exports, "getAzubisAsAusbilder", {
  enumerable: true,
  get: function get() {
    return _getAzubisAsAusbilder.getAzubisAsAusbilder;
  }
});
Object.defineProperty(exports, "getAzubisWithAbteilungenAsAusbilder", {
  enumerable: true,
  get: function get() {
    return _getAzubisWithAbteilungenAsAusbilder.getAzubisWithAbteilungenAsAusbilder;
  }
});
Object.defineProperty(exports, "getAzubisWithAusbildungsplanModul", {
  enumerable: true,
  get: function get() {
    return _getAzubisWithAusbildungsplanModul.getAzubisWithAusbildungsplanModul;
  }
});
Object.defineProperty(exports, "getAzubisWithPraxisaufgabenModul", {
  enumerable: true,
  get: function get() {
    return _getAzubisWithPraxisaufgabenModul.getAzubisWithPraxisaufgabenModul;
  }
});
Object.defineProperty(exports, "getAzubisWithVersetzungsplanModul", {
  enumerable: true,
  get: function get() {
    return _getAzubisWithVersetzungsplanModul.getAzubisWithVersetzungsplanModul;
  }
});
Object.defineProperty(exports, "getAzubisWithWissensportalModul", {
  enumerable: true,
  get: function get() {
    return _getAzubisWithWissensportalModul.getAzubisWithWissensportalModul;
  }
});
Object.defineProperty(exports, "getChapterStatusById", {
  enumerable: true,
  get: function get() {
    return _getChapterStatusById.getChapterStatusById;
  }
});
Object.defineProperty(exports, "getChapterStatusByIdAsAusbilder", {
  enumerable: true,
  get: function get() {
    return _getChapterStatusByIdAsAusbilder.getChapterStatusByIdAsAusbilder;
  }
});
Object.defineProperty(exports, "getChatActivities", {
  enumerable: true,
  get: function get() {
    return _getChatActivities.getChatActivities;
  }
});
Object.defineProperty(exports, "getFeedbackFile", {
  enumerable: true,
  get: function get() {
    return _getFeedbackFile.getFeedbackFile;
  }
});
Object.defineProperty(exports, "getFeedbackVorlagen", {
  enumerable: true,
  get: function get() {
    return _getFeedbackVorlagen.getFeedbackVorlagen;
  }
});
Object.defineProperty(exports, "getFeedbackVorlagenFile", {
  enumerable: true,
  get: function get() {
    return _getFeedbackVorlagenFile.getFeedbackVorlagenFile;
  }
});
Object.defineProperty(exports, "getHasNewChatActivities", {
  enumerable: true,
  get: function get() {
    return _getHasNewChatActivities.getHasNewChatActivities;
  }
});
Object.defineProperty(exports, "getMeinenRessourcenPlan", {
  enumerable: true,
  get: function get() {
    return _getMeinenRessourcenPlan.getMeinenRessourcenPlan;
  }
});
Object.defineProperty(exports, "getMissingAbteilungenForCopy", {
  enumerable: true,
  get: function get() {
    return _getMissingAbteilungenForCopy.getMissingAbteilungenForCopy;
  }
});
Object.defineProperty(exports, "getMyChats", {
  enumerable: true,
  get: function get() {
    return _getMyChats.getMyChats;
  }
});
Object.defineProperty(exports, "getMyFeedback", {
  enumerable: true,
  get: function get() {
    return _getMyFeedback.getMyFeedback;
  }
});
Object.defineProperty(exports, "getNachweisQualifikationen", {
  enumerable: true,
  get: function get() {
    return _getNachweisQualifikationen.getNachweisQualifikationen;
  }
});
Object.defineProperty(exports, "getNotifications", {
  enumerable: true,
  get: function get() {
    return _getNotifications.getNotifications;
  }
});
Object.defineProperty(exports, "getPraxisaufgaben", {
  enumerable: true,
  get: function get() {
    return _getPraxisaufgaben.getPraxisaufgaben;
  }
});
Object.defineProperty(exports, "getRessourcenForConflictCheck", {
  enumerable: true,
  get: function get() {
    return _getRessourcenForConflictCheck.getRessourcenForConflictCheck;
  }
});
Object.defineProperty(exports, "getSuperiorNamesForAzubi", {
  enumerable: true,
  get: function get() {
    return _getSuperiorNamesForAzubi.getSuperiorNamesForAzubi;
  }
});
Object.defineProperty(exports, "getUserAbteilungenForAzubi", {
  enumerable: true,
  get: function get() {
    return _getUserAbteilungenForAzubi.getUserAbteilungenForAzubi;
  }
});
Object.defineProperty(exports, "getUserAusbilder", {
  enumerable: true,
  get: function get() {
    return _getUserAusbilder.getUserAusbilder;
  }
});
Object.defineProperty(exports, "getUserById", {
  enumerable: true,
  get: function get() {
    return _getUserById.getUserById;
  }
});
Object.defineProperty(exports, "getUserFileUrl", {
  enumerable: true,
  get: function get() {
    return _getUserFileUrl.getUserFileUrl;
  }
});
Object.defineProperty(exports, "getUserModuleSettings", {
  enumerable: true,
  get: function get() {
    return _getUserModuleSettings.getUserModuleSettings;
  }
});
Object.defineProperty(exports, "getWissensportalDegreeOfCompletion", {
  enumerable: true,
  get: function get() {
    return _getWissensportalDegreeOfCompletion.getWissensportalDegreeOfCompletion;
  }
});
Object.defineProperty(exports, "hasAzubisWithNachweisModul", {
  enumerable: true,
  get: function get() {
    return _hasAzubisWithNachweisModul.hasAzubisWithNachweisModul;
  }
});
Object.defineProperty(exports, "invalidateRefreshToken", {
  enumerable: true,
  get: function get() {
    return _invalidateRefreshToken.invalidateRefreshToken;
  }
});
Object.defineProperty(exports, "login", {
  enumerable: true,
  get: function get() {
    return _login.login;
  }
});
Object.defineProperty(exports, "markAllNotificationsAsRead", {
  enumerable: true,
  get: function get() {
    return _markAllNotificationsAsRead.markAllNotificationsAsRead;
  }
});
Object.defineProperty(exports, "markChatAsRead", {
  enumerable: true,
  get: function get() {
    return _markChatAsRead.markChatAsRead;
  }
});
Object.defineProperty(exports, "markNotificationAsRead", {
  enumerable: true,
  get: function get() {
    return _markNotificationAsRead.markNotificationAsRead;
  }
});
Object.defineProperty(exports, "markNotificationAsUnread", {
  enumerable: true,
  get: function get() {
    return _markNotificationAsUnread.markNotificationAsUnread;
  }
});
Object.defineProperty(exports, "nachweisAblehnen", {
  enumerable: true,
  get: function get() {
    return _nachweisAblehnen.nachweisAblehnen;
  }
});
Object.defineProperty(exports, "nachweisEinreichen", {
  enumerable: true,
  get: function get() {
    return _nachweisEinreichen.nachweisEinreichen;
  }
});
Object.defineProperty(exports, "nachweisFreigabeZurueckziehen", {
  enumerable: true,
  get: function get() {
    return _nachweisFreigabeZurueckziehen.nachweisFreigabeZurueckziehen;
  }
});
Object.defineProperty(exports, "nachweisFreigeben", {
  enumerable: true,
  get: function get() {
    return _nachweisFreigeben.nachweisFreigeben;
  }
});
Object.defineProperty(exports, "postAnswer", {
  enumerable: true,
  get: function get() {
    return _ausbildungsplanPostAnswer.postAnswer;
  }
});
Object.defineProperty(exports, "postComment", {
  enumerable: true,
  get: function get() {
    return _ausbildungsplanPostComment.postComment;
  }
});
Object.defineProperty(exports, "prepareAufbauausbildung", {
  enumerable: true,
  get: function get() {
    return _prepareAufbauausbildung.prepareAufbauausbildung;
  }
});
Object.defineProperty(exports, "prepareReinitialization", {
  enumerable: true,
  get: function get() {
    return _prepareReinitialization.prepareReinitialization;
  }
});
Object.defineProperty(exports, "printAusbildungsplan", {
  enumerable: true,
  get: function get() {
    return _printAusbildungsplan.printAusbildungsplan;
  }
});
Object.defineProperty(exports, "printAusbildungsplanForCurrentUser", {
  enumerable: true,
  get: function get() {
    return _printAusbildungsplanForCurrentUser.printAusbildungsplanForCurrentUser;
  }
});
Object.defineProperty(exports, "printNachweisById", {
  enumerable: true,
  get: function get() {
    return _printNachweisById.printNachweisById;
  }
});
Object.defineProperty(exports, "printNachweisRangeAusbilder", {
  enumerable: true,
  get: function get() {
    return _printNachweisRange.printNachweisRangeAusbilder;
  }
});
Object.defineProperty(exports, "printNachweisRangeAzubi", {
  enumerable: true,
  get: function get() {
    return _printNachweisRange.printNachweisRangeAzubi;
  }
});
Object.defineProperty(exports, "publishAbteilungen", {
  enumerable: true,
  get: function get() {
    return _publishAbteilungen.publishAbteilungen;
  }
});
Object.defineProperty(exports, "readAusbildungsplanForAusbilderDashboard", {
  enumerable: true,
  get: function get() {
    return _readAusbildungsplanForAusbilderDashboard.readAusbildungsplanForAusbilderDashboard;
  }
});
Object.defineProperty(exports, "readAusbildungsplanForAzubiDashboard", {
  enumerable: true,
  get: function get() {
    return _readAusbildungsplanForAzubiDashboard.readAusbildungsplanForAzubiDashboard;
  }
});
Object.defineProperty(exports, "readNachweisDetails", {
  enumerable: true,
  get: function get() {
    return _readNachweisDetails.readNachweisDetails;
  }
});
Object.defineProperty(exports, "readNachweisList", {
  enumerable: true,
  get: function get() {
    return _readNachweisList.readNachweisList;
  }
});
Object.defineProperty(exports, "readPraxisaufgabenForAusbilderDashboard", {
  enumerable: true,
  get: function get() {
    return _readPraxisaufgabenForAusbilderDashboard.readPraxisaufgabenForAusbilderDashboard;
  }
});
Object.defineProperty(exports, "readPraxisaufgabenForAzubiDashboard", {
  enumerable: true,
  get: function get() {
    return _readPraxisaufgabenForAzubiDashboard.readPraxisaufgabenForAzubiDashboard;
  }
});
Object.defineProperty(exports, "readVersetzungsplan", {
  enumerable: true,
  get: function get() {
    return _readVersetzungsplan.readVersetzungsplan;
  }
});
Object.defineProperty(exports, "readVersetzungsplanTermine", {
  enumerable: true,
  get: function get() {
    return _readVersetzungsplanTermine.readVersetzungsplanTermine;
  }
});
Object.defineProperty(exports, "saveAttachmentToNachweis", {
  enumerable: true,
  get: function get() {
    return _saveAttachmentToNachweis.saveAttachmentToNachweis;
  }
});
Object.defineProperty(exports, "searchChatParticipant", {
  enumerable: true,
  get: function get() {
    return _searchChatParticipant.searchChatParticipant;
  }
});
Object.defineProperty(exports, "setUserAusbilder", {
  enumerable: true,
  get: function get() {
    return _setUserAusbilder.setUserAusbilder;
  }
});
Object.defineProperty(exports, "syncNachweis", {
  enumerable: true,
  get: function get() {
    return _syncNachweis.syncNachweis;
  }
});
Object.defineProperty(exports, "updateAbteilungenAsFachausbilder", {
  enumerable: true,
  get: function get() {
    return _updateAbteilungenAsFachausbilder.updateAbteilungenAsFachausbilder;
  }
});
Object.defineProperty(exports, "updateAufgabeDone", {
  enumerable: true,
  get: function get() {
    return _updateAufgabeDone.updateAufgabeDone;
  }
});
Object.defineProperty(exports, "updateAusbilderAbteilungen", {
  enumerable: true,
  get: function get() {
    return _updateAusbilderAbteilungen.updateAusbilderAbteilungen;
  }
});
Object.defineProperty(exports, "updateAusbildungsjahr", {
  enumerable: true,
  get: function get() {
    return _updateAusbildungsjahr.updateAusbildungsjahr;
  }
});
Object.defineProperty(exports, "updateAusbildungsnachweisAbteilungById", {
  enumerable: true,
  get: function get() {
    return _updateAusbildungsnachweisAbteilungById.updateAusbildungsnachweisAbteilungById;
  }
});
Object.defineProperty(exports, "updateAusbildungsnachweisAbteilungByName", {
  enumerable: true,
  get: function get() {
    return _updateAusbildungsnachweisAbteilungByName.updateAusbildungsnachweisAbteilungByName;
  }
});
Object.defineProperty(exports, "updateAusbildungsnachweisTyp", {
  enumerable: true,
  get: function get() {
    return _updateAusbildungsnachweisTyp.updateAusbildungsnachweisTyp;
  }
});
Object.defineProperty(exports, "updateChat", {
  enumerable: true,
  get: function get() {
    return _updateChat.updateChat;
  }
});
Object.defineProperty(exports, "updateProfileImage", {
  enumerable: true,
  get: function get() {
    return _updateProfileImage.updateProfileImage;
  }
});
Object.defineProperty(exports, "updateTaetigkeit", {
  enumerable: true,
  get: function get() {
    return _updateTaetigkeit.updateTaetigkeit;
  }
});
Object.defineProperty(exports, "updateTermin", {
  enumerable: true,
  get: function get() {
    return _updateTermin.updateTermin;
  }
});
Object.defineProperty(exports, "uploadAzubiZuAbteilungFeedback", {
  enumerable: true,
  get: function get() {
    return _uploadAzubiZuAbteilungFeedback.uploadAzubiZuAbteilungFeedback;
  }
});
Object.defineProperty(exports, "uploadAzubiZuAllgemeinFeedback", {
  enumerable: true,
  get: function get() {
    return _uploadAzubiZuAllgemeinFeedback.uploadAzubiZuAllgemeinFeedback;
  }
});
Object.defineProperty(exports, "uploadFeedbackAnAzubi", {
  enumerable: true,
  get: function get() {
    return _uploadFeedbackAnAzubi.uploadFeedbackAnAzubi;
  }
});
Object.defineProperty(exports, "uploadFile", {
  enumerable: true,
  get: function get() {
    return _uploadFile.uploadFile;
  }
});
var _ablehnenAusbildungsplan = require("./ablehnenAusbildungsplan");
var _acceptPrivacyPolicy = require("./acceptPrivacyPolicy");
var _addChatParticipant = require("./addChatParticipant");
var _ausbildungsplanGetAnswers = require("./ausbildungsplanGetAnswers");
var _ausbildungsplanGetAnswersAsAusbilder = require("./ausbildungsplanGetAnswersAsAusbilder");
var _ausbildungsplanPostAnswer = require("./ausbildungsplanPostAnswer");
var _ausbildungsplanPostComment = require("./ausbildungsplanPostComment");
var _automaticallySelectCurrentAbteilungForAzubi = require("./automaticallySelectCurrentAbteilungForAzubi");
var _calculateConflictsForAzubi = require("./calculateConflictsForAzubi");
var _commentAufgabe = require("./commentAufgabe");
var _copyVersetzungsplan = require("./copyVersetzungsplan");
var _createAbteilung = require("./createAbteilung");
var _createAufgabe = require("./createAufgabe");
var _createChat = require("./createChat");
var _createChatActivity = require("./createChatActivity");
var _createNachweis = require("./createNachweis");
var _createNote = require("./createNote");
var _createNotificationsForSelectedAzubiGroups = require("./createNotificationsForSelectedAzubiGroups");
var _createOrUpdateRessourcenplanung = require("./createOrUpdateRessourcenplanung");
var _createTaetigkeit = require("./createTaetigkeit");
var _createTermin = require("./createTermin");
var _createTerminAsAusbilder = require("./createTerminAsAusbilder");
var _deleteAbteilung = require("./deleteAbteilung");
var _deleteAttachmentFromNachweis = require("./deleteAttachmentFromNachweis");
var _deleteAufgabe = require("./deleteAufgabe");
var _deleteImage = require("./deleteImage");
var _deleteProfileImage = require("./deleteProfileImage");
var _deleteTaetigkeit = require("./deleteTaetigkeit");
var _deleteTermin = require("./deleteTermin");
var _deleteUserAusbilder = require("./deleteUserAusbilder");
var _deviceRegister = require("./deviceRegister");
var _deviceUnregister = require("./deviceUnregister");
var _editAbteilung = require("./editAbteilung");
var _einreichenAusbildungsplan = require("./einreichenAusbildungsplan");
var _freigabeZurueckziehenAusbildungsplan = require("./freigabeZurueckziehenAusbildungsplan");
var _freigebenAusbildungsplan = require("./freigebenAusbildungsplan");
var _getAbteilungenAsFachausbilder = require("./getAbteilungenAsFachausbilder");
var _getAbteilungenForAzubi = require("./getAbteilungenForAzubi");
var _getAllAbteilungen = require("./getAllAbteilungen");
var _getAllChaptersStatusByUser = require("./getAllChaptersStatusByUser");
var _getAllChaptersStatusFromMyAzubis = require("./getAllChaptersStatusFromMyAzubis");
var _getAllCourses = require("./getAllCourses");
var _getAllCoursesForAzubis = require("./getAllCoursesForAzubis");
var _getArchivedAusbildungsnachweise = require("./getArchivedAusbildungsnachweise");
var _getAufgabenByAbteilung = require("./getAufgabenByAbteilung");
var _getAusbilder = require("./getAusbilder");
var _getAusbilderAsTrainer = require("./getAusbilderAsTrainer");
var _getAusbilderFeedItems = require("./getAusbilderFeedItems");
var _getAusbildungsnachweiseAusbilderDashboard = require("./getAusbildungsnachweiseAusbilderDashboard");
var _getAusbildungsnachweiseAzubiDashboard = require("./getAusbildungsnachweiseAzubiDashboard");
var _getAusbildungsplan = require("./getAusbildungsplan");
var _getAzubisAsAusbilder = require("./getAzubisAsAusbilder");
var _getAzubisWithAbteilungenAsAusbilder = require("./getAzubisWithAbteilungenAsAusbilder");
var _getAzubisWithAusbildungsplanModul = require("./getAzubisWithAusbildungsplanModul");
var _getAzubisWithPraxisaufgabenModul = require("./getAzubisWithPraxisaufgabenModul");
var _getAzubisWithVersetzungsplanModul = require("./getAzubisWithVersetzungsplanModul");
var _getAzubisWithWissensportalModul = require("./getAzubisWithWissensportalModul");
var _getChapterStatusById = require("./getChapterStatusById");
var _getChapterStatusByIdAsAusbilder = require("./getChapterStatusByIdAsAusbilder");
var _getChatActivities = require("./getChatActivities");
var _getFeedbackFile = require("./getFeedbackFile");
var _getFeedbackVorlagen = require("./getFeedbackVorlagen");
var _getFeedbackVorlagenFile = require("./getFeedbackVorlagenFile");
var _getHasNewChatActivities = require("./getHasNewChatActivities");
var _getMeinenRessourcenPlan = require("./getMeinenRessourcenPlan");
var _getMissingAbteilungenForCopy = require("./getMissingAbteilungenForCopy");
var _getMyChats = require("./getMyChats");
var _getMyFeedback = require("./getMyFeedback");
var _getNachweisQualifikationen = require("./getNachweisQualifikationen");
var _getNotifications = require("./getNotifications");
var _getPraxisaufgaben = require("./getPraxisaufgaben");
var _getRessourcenForConflictCheck = require("./getRessourcenForConflictCheck");
var _getSuperiorNamesForAzubi = require("./getSuperiorNamesForAzubi");
var _getUserAbteilungenForAzubi = require("./getUserAbteilungenForAzubi");
var _getUserAusbilder = require("./getUserAusbilder");
var _getUserById = require("./getUserById");
var _getUserFileUrl = require("./getUserFileUrl");
var _getUserModuleSettings = require("./getUserModuleSettings");
var _getWissensportalDegreeOfCompletion = require("./getWissensportalDegreeOfCompletion");
var _hasAzubisWithNachweisModul = require("./hasAzubisWithNachweisModul");
var _invalidateRefreshToken = require("./invalidateRefreshToken");
var _login = require("./login");
var _markAllNotificationsAsRead = require("./markAllNotificationsAsRead");
var _markChatAsRead = require("./markChatAsRead");
var _markNotificationAsRead = require("./markNotificationAsRead");
var _markNotificationAsUnread = require("./markNotificationAsUnread");
var _nachweisAblehnen = require("./nachweisAblehnen");
var _nachweisEinreichen = require("./nachweisEinreichen");
var _nachweisFreigabeZurueckziehen = require("./nachweisFreigabeZurueckziehen");
var _nachweisFreigeben = require("./nachweisFreigeben");
var _prepareAufbauausbildung = require("./prepareAufbauausbildung");
var _prepareReinitialization = require("./prepareReinitialization");
var _printNachweisById = require("./printNachweisById");
var _printNachweisRange = require("./printNachweisRange");
var _printAusbildungsplan = require("./printAusbildungsplan");
var _printAusbildungsplanForCurrentUser = require("./printAusbildungsplanForCurrentUser");
var _publishAbteilungen = require("./publishAbteilungen");
var _readAusbildungsplanForAusbilderDashboard = require("./readAusbildungsplanForAusbilderDashboard");
var _readAusbildungsplanForAzubiDashboard = require("./readAusbildungsplanForAzubiDashboard");
var _readNachweisDetails = require("./readNachweisDetails");
var _readNachweisList = require("./readNachweisList");
var _readPraxisaufgabenForAusbilderDashboard = require("./readPraxisaufgabenForAusbilderDashboard");
var _readPraxisaufgabenForAzubiDashboard = require("./readPraxisaufgabenForAzubiDashboard");
var _readVersetzungsplan = require("./readVersetzungsplan");
var _readVersetzungsplanTermine = require("./readVersetzungsplanTermine");
var _saveAttachmentToNachweis = require("./saveAttachmentToNachweis");
var _searchChatParticipant = require("./searchChatParticipant");
var _setUserAusbilder = require("./setUserAusbilder");
var _syncNachweis = require("./syncNachweis");
var _updateAbteilungenAsFachausbilder = require("./updateAbteilungenAsFachausbilder");
var _updateAufgabeDone = require("./updateAufgabeDone");
var _updateAusbilderAbteilungen = require("./updateAusbilderAbteilungen");
var _updateAusbildungsjahr = require("./updateAusbildungsjahr");
var _updateAusbildungsnachweisAbteilungById = require("./updateAusbildungsnachweisAbteilungById");
var _updateAusbildungsnachweisAbteilungByName = require("./updateAusbildungsnachweisAbteilungByName");
var _updateAusbildungsnachweisTyp = require("./updateAusbildungsnachweisTyp");
var _updateChat = require("./updateChat");
var _updateProfileImage = require("./updateProfileImage");
var _updateTaetigkeit = require("./updateTaetigkeit");
var _updateTermin = require("./updateTermin");
var _uploadAzubiZuAbteilungFeedback = require("./uploadAzubiZuAbteilungFeedback");
var _uploadAzubiZuAllgemeinFeedback = require("./uploadAzubiZuAllgemeinFeedback");
var _uploadFeedbackAnAzubi = require("./uploadFeedbackAnAzubi");
var _uploadFile = require("./uploadFile");